import { forwardRef } from "react";

import {
  fieldMessageIconVariants,
  fieldMessageVariants,
  type FieldMessageVariants,
} from "./field-message.styles";
import { toFieldMessageIconName } from "./field-message.utils";
import { Icon } from "./icon";
import type { IconName } from "./icon.names";

export type FieldMessageRef = React.ComponentRef<"div">;

export interface FieldMessageProps
  extends React.ComponentPropsWithoutRef<"div">, FieldMessageVariants {
  iconName?: IconName | null;
}

const FieldMessage = forwardRef<FieldMessageRef, FieldMessageProps>(
  ({ children, className, iconName, intent, ...props }, ref) => {
    const fieldMessageIconName = toFieldMessageIconName(intent, iconName);
    return (
      <div
        {...props}
        className={fieldMessageVariants({ className, intent })}
        ref={ref}
      >
        {!!children && fieldMessageIconName ? (
          <Icon
            name={fieldMessageIconName}
            size="sm"
            className={fieldMessageIconVariants({ intent })}
          />
        ) : null}
        {children}
      </div>
    );
  },
);

FieldMessage.displayName = "FieldMessage";

export { FieldMessage };
